/**
 * Enable OwF Faire Academy content
 */
export const OWF_FAIRE_ACADEMY_231122 = 'OWF_FAIRE_ACADEMY_231122';
